<template>
  <div id="lyactive" v-if="openFormActive">
    <span id="text"
      >{{
        activeTitle
      }}，为了不影响系统功能正常使用，请联系服务商取得激活码进行激活</span
    >
    <Button @click="openForm = true">立即激活</Button>
    <Modal v-model="openForm" title="系统激活" footer-hide width="600">
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="激活码" prop="code">
              <Input
                v-model="item.code"
                :rows="5"
                type="textarea"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">清空激活码</Button>
              <Button @click="activation('item')" id="lyactivebtn"
                >提交授权码</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      item: {
        code: "",
      },
      ruleValidate: {
        code: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },
      activeTitle: "",
      openFormActive: false,
    };
  },
  methods: {
    jquary() {
      axios({
        method: "post",
        url: axios.commonAuth + "/system/select",
        data: {},
      }).then((res) => {
        console.log(res);
        this.openFormActive=false;
        var data = res.data.data;
        if (data.expiredTime != null) {
          var dd = data.expiredTime;
          var now = Date.now();
          var kk = (dd - now) / 86400000;
          var day = Math.floor(kk);
          if (day <= 15) {
            this.openFormActive = true;
            this.activeTitle = "本系统服务将于" + day + "天后到期";
            if (day ==0) {
              this.activeTitle = "本系统服务今天期";
            }
            if (day < 0) {
              this.activeTitle = "本系统服务已到期";
            }
          }
        }
        var enabled=res.data.data.enabled
        if (!enabled) {
            this.openFormActive = true;
            this.activeTitle = "本系统服务已被禁用";
        }
      });
    },
    activation(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          axios({
            method: "post",
            url: axios.commonAuth + "/system/activation",
            data: {
              code: this.item,
            },
          }).then((res) => {
            if (res) {
              location.reload();
            }
          });
        }
      });
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
  },
  mounted() {
    this.jquary();
  },
};
</script>
<style lang="">
#lyactive {
  width: 100%;
  background: #fcf053;
  padding: 6px 15px;
}
#lyactive span#text {
  color: red;
  margin-right: 10px;
}
#lyactivebtn {
  background: var(--loginColor);
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/login/active.vue